import {
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  signOut,
} from "firebase/auth";
import { auth  } from '../firebase/firebase-config'



const logInWithEmailAndPassword = (email, password) => signInWithEmailAndPassword(auth, email, password);
  
const sendPasswordReset = async (email) => {
  try {
    await sendPasswordResetEmail(auth, email);
    alert("Password reset link sent!");
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};

const logout = () => {
  signOut(auth);
};

export {
  logInWithEmailAndPassword,
  sendPasswordReset,
  logout,
};
